export enum RoleType {
  SYSTEM = 1,
  PHARMACY = 2,
  OTHER = 3,
}
